/**
 * usePageTitle — met à jour le <title> du document (RGAA 2.4.2 / WCAG).
 *
 * Chaque page doit avoir un titre unique et descriptif, annoncé par les lecteurs
 * d'écran au changement de page. On compose « {titre} — VisionPro Collectivité ».
 * Le titre est restauré au démontage pour éviter les fuites entre navigations.
 *
 * Usage :
 *   usePageTitle('Alertes municipales');
 *   → <title>Alertes municipales — VisionPro Collectivité</title>
 *
 * Appelé automatiquement par AppHeader (via son libellé `module`) et PublicLayout,
 * donc la plupart des pages sont couvertes sans changement. Une page peut aussi
 * l'appeler directement pour un titre plus précis.
 */

import { useEffect } from 'react';

const SUFFIX = 'VisionPro Collectivité';

export function usePageTitle(titre: string | null | undefined): void {
  useEffect(() => {
    const previous = document.title;
    document.title = titre && titre.trim() ? `${titre.trim()} — ${SUFFIX}` : SUFFIX;
    return () => { document.title = previous; };
  }, [titre]);
}
